import { Navigate, useParams } from "react-router-dom";
import SaveProspectoCorporativo from "../../shared/component/save_prospecto_corporativo/SaveProspectoCorporativo";
import { useGetProspectoByIdProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";

export default function EditProspectoCorporativoPage() {
  const { id } = useParams();
  const { data, isLoading } = useGetProspectoByIdProspectoCorporativo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data) return <Navigate to={ROUTER_PATHS.ventasCorporativas.prospectoCorporativoNav} />;

  return (
    <>
      <SaveProspectoCorporativo title="Revisión de Prospecto Corporativo" enableEdit={true} prospecto_corporativo={data} />
    </>
  )
  
}